import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { CheckboxTheme } from './checkbox.config';

@Component({
  selector: 'dn-checkbox',
  templateUrl: './dn-checkbox.component.html',
  styleUrl: './dn-checkbox.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class DnCheckboxComponent {
  @Input() text: string;
  @Input() indeterminate: boolean;

  @Input() theme: CheckboxTheme = CheckboxTheme.Green;
  @Input() checkboxState = false;
  @Output() checkboxStateChanged: EventEmitter<boolean> = new EventEmitter();

  checkboxClick(event: MatCheckboxChange): void {
    this.checkboxState = event.checked;
    this.checkboxStateChanged.emit(this.checkboxState);
  }

  stopPropagation(event: Event): void {
    event.stopPropagation();
  }
}
